<script setup lang="ts">
import RouterViewTransition from '@/core/components/RouterViewTransition.vue'
import LanguageSwitcher from '@/core/components/LanguageSwitcher.vue'

document.body.className = 'dev'
</script>

<template>
  <RouterViewTransition />
</template>

<style>
body.dev {
  background: #4c5b5e;
}

body.dev #app {
  width: auto;
  height: auto;
  padding: 0;
  color: #d7a66a;
  background-color: #4c5b5e; 
}
</style>
